/* Luxmi Estates editorial theme — storefront behaviour (works with real Shopify cart, search and sections). */
(function () {
  'use strict';
  var d = document, body = d.body;
  var R = window.EditorialRoutes || {};
  var ROOT = R.root || '/';
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* ---------- Layers: cart drawer, menu drawer, search ---------- */
  var lastTrigger = null;
  function openLayer(el, trigger) {
    if (!el) return;
    lastTrigger = trigger || d.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    body.classList.add('is-locked');
    var f = el.querySelector('input[type=search], button, a[href]');
    if (f) setTimeout(function () { f.focus(); }, 80);
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + el.id + '"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (!$('[data-layer].is-open')) body.classList.remove('is-locked');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  function cartDrawer() { return d.getElementById('CartDrawer'); }

  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open],[data-cart-close],[data-search-open],[data-search-close],[data-drawer-open],[data-drawer-close],[data-qty-step]');
    if (!t) return;
    if (t.hasAttribute('data-qty-step')) {
      var input = t.parentElement.querySelector('input[type=number]');
      if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(t.getAttribute('data-qty-step'), 10));
      return;
    }
    e.preventDefault();
    if (t.hasAttribute('data-cart-open')) openLayer(cartDrawer(), t);
    else if (t.hasAttribute('data-cart-close')) closeLayer(cartDrawer());
    else if (t.hasAttribute('data-search-open')) openLayer(d.getElementById(t.getAttribute('aria-controls')), t);
    else if (t.hasAttribute('data-drawer-open')) openLayer(d.getElementById(t.getAttribute('data-drawer-open')), t);
    else closeLayer(t.closest('[data-layer]'));
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('[data-layer].is-open').forEach(closeLayer);
  });

  /* ---------- Mega menu ---------- */
  $$('[data-mega-root]').forEach(function (root) {
    var btn = $('[data-mega-toggle]', root);
    var panel = btn && d.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var timer;
    function set(open) { panel.hidden = !open; btn.setAttribute('aria-expanded', String(open)); }
    btn.addEventListener('click', function () { set(panel.hidden); });
    if (window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseenter', function () { clearTimeout(timer); set(true); });
      root.addEventListener('mouseleave', function () { timer = setTimeout(function () { set(false); }, 150); });
    }
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) set(false); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); } });
  });

  /* ---------- Predictive search (server-rendered by sections/predictive-search.liquid) ---------- */
  $$('[data-predictive-search]').forEach(function (root) {
    var input = $('input[type=search]', root);
    var out = $('[data-search-results]', root);
    if (!input || !out) return;
    var initial = out.innerHTML, timer, seq = 0;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = initial; return; }
      timer = setTimeout(function () {
        var mine = ++seq;
        var url = (R.predictive || ROOT + 'search/suggest') + '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search&resources[type]=product,query,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          if (mine !== seq) return;
          var tmp = d.createElement('div'); tmp.innerHTML = html;
          var inner = tmp.querySelector('[data-predictive-results]');
          out.innerHTML = inner && inner.children.length ? inner.innerHTML : initial;
        }).catch(function () {});
      }, 180);
    });
  });

  /* ---------- Cart: AJAX add/change + live drawer re-render ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
    var icon = d.getElementById('cart-icon-bubble');
    if (icon) icon.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
  }
  function renderDrawer(open) {
    return fetch(ROOT + (ROOT.slice(-1) === '/' ? '' : '/') + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = d.createElement('div'); tmp.innerHTML = data['cart-drawer'] || '';
        var fresh = tmp.querySelector('#CartDrawer'), old = cartDrawer();
        if (!fresh || !old) return;
        var keep = open || old.classList.contains('is-open');
        old.parentNode.replaceChild(fresh, old);
        if (keep) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); body.classList.add('is-locked'); }
        setCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
      });
  }
  function post(url, form, submitter) {
    var fd = new FormData(form);
    if (submitter && submitter.name) fd.set(submitter.name, submitter.value);
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function flash(form, msg) {
    var el = form.querySelector('[data-form-error]');
    if (!el) { el = d.createElement('p'); el.className = 'editorial-form-error'; el.setAttribute('data-form-error', ''); el.setAttribute('role', 'alert'); form.appendChild(el); }
    el.textContent = msg;
  }
  d.addEventListener('submit', function (e) {
    var f = e.target, action = f.getAttribute('action') || '';
    var isAdd = action.indexOf('/cart/add') !== -1, isChange = f.hasAttribute('data-cart-change');
    if (!isAdd && !isChange) return;
    e.preventDefault();
    var btn = e.submitter || f.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    var url = (isAdd ? (R.cartAdd || ROOT + 'cart/add') : (R.cartChange || ROOT + 'cart/change')) + '.js';
    post(url, f, isChange ? btn : null)
      .then(function () { if (isAdd) lastTrigger = btn; return renderDrawer(isAdd); })
      .catch(function (err) { flash(f, (err && (err.description || err.message)) || 'Something went wrong. Please try again.'); })
      .then(function () { if (btn && btn.isConnected) btn.disabled = false; });
  });

  /* ---------- Time-of-day ritual tabs ---------- */
  $$('[data-ritual-now]').forEach(function (root) {
    var tabs = $$('[data-ritual-tab]', root);
    if (!tabs.length) return;
    var clock = $('[data-ritual-clock]', root);
    function select(key, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-ritual-tab') === key;
        t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      $$('[data-ritual-panel]', root).forEach(function (p) {
        var on = p.getAttribute('data-ritual-panel') === key;
        p.hidden = !on; p.classList.toggle('is-entering', on);
      });
      $$('[data-ritual-img]', root).forEach(function (i) { i.classList.toggle('is-active', i.getAttribute('data-ritual-img') === key); });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.getAttribute('data-ritual-tab')); });
      t.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (dir) { e.preventDefault(); select(tabs[(i + dir + tabs.length) % tabs.length].getAttribute('data-ritual-tab'), true); }
      });
    });
    var now = new Date(), hr = now.getHours();
    var key = hr >= 5 && hr < 12 ? 'morning' : hr >= 12 && hr < 17 ? 'afternoon' : 'evening';
    if (!tabs.some(function (t) { return t.getAttribute('data-ritual-tab') === key; })) key = tabs[0].getAttribute('data-ritual-tab');
    if (clock) clock.textContent = 'It’s ' + now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }).toLowerCase() + ' where you are';
    select(key);
  });

  /* ---------- Advent calendar preview ---------- */
  $$('[data-advent-preview]').forEach(function (root) {
    var KEY = 'luxmi-advent-preview';
    var pockets = $$('[data-advent-day]', root), total = pockets.length;
    if (!total) return;
    var count = $('[data-advent-count]', root), live = $('[data-advent-live]', root), toggle = $('[data-advent-toggle]', root);
    var saved = [];
    try { saved = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    function set(p, open) {
      p.setAttribute('aria-pressed', String(open));
      p.setAttribute('aria-label', open ? 'Day ' + p.dataset.adventDay + ': ' + p.dataset.tea : 'Day ' + p.dataset.adventDay);
    }
    function opened() { return pockets.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; }); }
    function sync() {
      var o = opened();
      if (count) count.textContent = o.length + ' of ' + total + ' opened';
      if (toggle) toggle.textContent = o.length === total ? 'Close all' : 'Open all';
      try { localStorage.setItem(KEY, JSON.stringify(o.map(function (p) { return p.dataset.adventDay; }))); } catch (e) {}
    }
    pockets.forEach(function (p) {
      if (saved.indexOf(p.dataset.adventDay) > -1) set(p, true);
      p.addEventListener('click', function () {
        var open = p.getAttribute('aria-pressed') !== 'true';
        set(p, open);
        if (live) live.textContent = open ? 'Day ' + p.dataset.adventDay + ' · ' + p.dataset.tea : '';
        sync();
      });
    });
    if (toggle) toggle.addEventListener('click', function () {
      var openAll = opened().length !== total;
      pockets.forEach(function (p, i) { setTimeout(function () { set(p, openAll); if (i === total - 1) sync(); }, i * 35); });
      if (live) live.textContent = openAll ? 'All ' + total + ' teas, from ' + pockets[0].dataset.tea + ' to ' + pockets[total - 1].dataset.tea + '.' : '';
    });
    sync();
  });

  /* ---------- Steeping timer ---------- */
  $$('[data-steep-timer]').forEach(function (root) {
    var C = 276.46;
    var display = $('[data-timer-display]', root), bar = $('[data-timer-bar]', root);
    var start = $('[data-timer-start]', root), status = $('[data-timer-status]', root), resetBtn = $('[data-timer-reset]', root);
    if (!display || !bar || !start) return;
    var pressed = $('[data-steep-seconds][aria-pressed="true"]', root) || $('[data-steep-seconds]', root);
    var total = pressed ? parseInt(pressed.getAttribute('data-steep-seconds'), 10) : 300, left = total, timer = null;
    var msg = {
      ready: root.getAttribute('data-msg-ready') || (status ? status.textContent : ''),
      steeping: root.getAttribute('data-msg-steeping') || 'Steeping. Give it the full time.',
      done: root.getAttribute('data-msg-done') || 'Ready. Lift out the leaves and enjoy.'
    };
    function fmt(s) { return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }
    function draw() { display.textContent = fmt(left); bar.style.strokeDashoffset = (C * (1 - left / total)).toFixed(2); }
    function say(t) { if (status) status.textContent = t; }
    function stop() { clearInterval(timer); timer = null; start.textContent = left < total && left > 0 ? 'Resume' : 'Start'; }
    function reset(s) { stop(); total = left = s || total; root.classList.remove('is-done'); start.textContent = 'Start'; say(msg.ready); draw(); }
    start.addEventListener('click', function () {
      if (timer) { stop(); say('Paused at ' + fmt(left) + '.'); return; }
      if (left === 0) reset();
      start.textContent = 'Pause'; say(msg.steeping);
      timer = setInterval(function () {
        left -= 1; draw();
        if (left <= 0) { stop(); start.textContent = 'Again'; root.classList.add('is-done'); say(msg.done); }
      }, 1000);
    });
    if (resetBtn) resetBtn.addEventListener('click', function () { reset(); });
    $$('[data-steep-seconds]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-steep-seconds]', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        reset(parseInt(b.getAttribute('data-steep-seconds'), 10));
      });
    });
    draw();
  });

  /* ---------- Estates atlas (D3 + topojson loaded by sections/estates-map.liquid) ---------- */
  $$('[data-estates-atlas]').forEach(function (atlas) {
    var section = atlas.closest('section') || d;
    var mapEl = $('[data-estates-map]', atlas), detail = $('[data-estates-detail]', atlas);
    var list = $('.section-estates__list', section), cards = $$('[data-estate]', section);
    if (!mapEl || !cards.length) return;
    var W = 960, H = 560, markers = {}, proj;
    if (window.d3 && window.topojson) {
      proj = d3.geoMercator().fitExtent([[60, 50], [W - 60, H - 50]], { type: 'MultiPoint', coordinates: [[24, -8], [100, 33]] });
      var svg = d3.select(mapEl).insert('svg', ':first-child').attr('viewBox', '0 0 ' + W + ' ' + H).attr('preserveAspectRatio', 'none').attr('aria-hidden', 'true');
      var path = d3.geoPath(proj);
      svg.append('path').attr('class', 'section-estates__graticule').attr('d', path(d3.geoGraticule().step([10, 10])()));
      var land = svg.append('g');
      fetch('https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-110m.json').then(function (r) { return r.json(); }).then(function (topo) {
        var feats = topojson.feature(topo, topo.objects.countries).features;
        land.selectAll('path').data(feats).join('path')
          .attr('class', function (f) { return 'section-estates__land' + (f.id === '356' || f.id === '646' ? ' section-estates__land--home' : ''); })
          .attr('data-iso', function (f) { return f.id; })
          .attr('d', path);
        var url = mapEl.getAttribute('data-india-url');
        if (!url) return;
        return fetch(url).then(function (r) { if (!r.ok) throw new Error('no official boundary'); return r.json(); }).then(function (india) {
          var geom = india.geometry || (india.features && india.features[0] && india.features[0].geometry) || india;
          (geom.type === 'Polygon' ? [geom.coordinates] : geom.coordinates).forEach(function (poly) {
            if (d3.geoArea({ type: 'Polygon', coordinates: poly }) > 2 * Math.PI) poly.forEach(function (ring) { ring.reverse(); });
          });
          land.select('[data-iso="356"]').remove();
          land.append('path').attr('class', 'section-estates__land section-estates__land--home').attr('d', path(geom));
        });
      }).catch(function () {});
    } else {
      proj = function (p) { return [(p[0] - 20) / 84 * W, (36 - p[1]) / 46 * H]; };
    }
    function fmt(v, pos, neg) { return Math.abs(v).toFixed(2) + '° ' + (v >= 0 ? pos : neg); }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function text(c, s) { var el = c.querySelector(s); return el ? el.textContent : ''; }
    function setActive(key, fromUser) {
      cards.forEach(function (c, i) {
        var on = c.dataset.estate === key;
        c.classList.toggle('is-active', on && fromUser);
        markers[c.dataset.estate].classList.toggle('is-active', on);
        markers[c.dataset.estate].setAttribute('aria-pressed', String(on));
        var an = mapEl.querySelector('[data-animal-for="' + c.dataset.estate + '"]'); if (an) an.classList.toggle('is-active', on);
        if (!on || !detail) return;
        detail.querySelector('[data-d=index]').textContent = 'Estate ' + pad(i + 1) + ' of ' + pad(cards.length);
        detail.querySelector('[data-d=name]').textContent = text(c, '.section-estates__name');
        detail.querySelector('[data-d=region]').textContent = text(c, '.section-estates__region');
        detail.querySelector('[data-d=terroir]').textContent = text(c, '.section-estates__terroir');
        detail.querySelector('[data-d=coords]').textContent = fmt(+c.dataset.lat, 'N', 'S') + ', ' + fmt(+c.dataset.lng, 'E', 'W');
        var link = detail.querySelector('[data-d=link]'), src = c.querySelector('.section-estates__link');
        if (link && src) { link.textContent = src.textContent; link.href = src.getAttribute('href'); }
      });
      if (list) list.classList.toggle('has-active', !!fromUser);
      if (detail) { detail.classList.remove('is-entering'); void detail.offsetWidth; detail.classList.add('is-entering'); }
    }
    var base = mapEl.getAttribute('data-asset-base') || '';
    cards.forEach(function (c) {
      var b = d.createElement('button');
      b.type = 'button'; b.className = 'section-estates__marker'; b.dataset.labelSide = c.dataset.labelSide || 'right';
      var name = text(c, '.section-estates__name');
      b.setAttribute('aria-label', name + ', ' + text(c, '.section-estates__region'));
      var dot = d.createElement('span'); dot.className = 'section-estates__marker-dot';
      var lab = d.createElement('span'); lab.className = 'section-estates__marker-label'; lab.setAttribute('aria-hidden', 'true'); lab.textContent = name;
      b.appendChild(dot); b.appendChild(lab);
      ['mouseenter', 'focus', 'click'].forEach(function (ev) { b.addEventListener(ev, function () { setActive(c.dataset.estate, false); }); });
      var p = proj([+c.dataset.lng, +c.dataset.lat]);
      b.style.left = (p[0] / W * 100) + '%'; b.style.top = (p[1] / H * 100) + '%';
      mapEl.appendChild(b); markers[c.dataset.estate] = b;
      var motif = c.getAttribute('data-motif');
      if (motif && motif !== 'none') {
        var a = d.createElement('span'), ap = proj([+(c.dataset.motifLng || c.dataset.lng), +(c.dataset.motifLat || c.dataset.lat)]);
        a.className = 'section-estates__animal'; a.setAttribute('aria-hidden', 'true'); a.dataset.animalFor = c.dataset.estate;
        a.style.left = (ap[0] / W * 100) + '%'; a.style.top = (ap[1] / H * 100) + '%';
        a.style.webkitMaskImage = a.style.maskImage = 'url("' + base + 'symbol-' + motif + '.png")';
        mapEl.insertBefore(a, mapEl.querySelector('.section-estates__marker'));
      }
      ['mouseenter', 'focusin'].forEach(function (ev) { c.addEventListener(ev, function () { setActive(c.dataset.estate, true); }); });
    });
    if (list) list.addEventListener('mouseleave', function () { list.classList.remove('has-active'); cards.forEach(function (c) { c.classList.remove('is-active'); }); });
    setActive(cards[0].dataset.estate, false);
  });

  /* ---------- Scroll reveals + hero parallax ---------- */
  (function () {
    var els = $$('[data-reveal]');
    els.forEach(function (el) {
      var sibs = Array.prototype.filter.call(el.parentElement.children, function (s) { return s.hasAttribute('data-reveal'); });
      if (sibs.length < 2 && el.parentElement.parentElement) sibs = $$(':scope > * > [data-reveal]', el.parentElement.parentElement);
      el.style.setProperty('--reveal-i', Math.max(0, sibs.indexOf(el)) % 6);
    });
    function revealAll() { els.forEach(function (el) { el.classList.add('is-revealed'); }); }
    els.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-revealed'); });
    if (!('IntersectionObserver' in window)) { revealAll(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { if (!el.classList.contains('is-revealed')) io.observe(el); });
  })();
  (function () {
    var heroMedia = $('.section-hero-gifting__media');
    if (!heroMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function update() {
      var r = heroMedia.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) heroMedia.style.setProperty('--hero-parallax', Math.max(-48, Math.min(48, -r.top * 0.12)).toFixed(1) + 'px');
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  })();
})();
